import { render, staticRenderFns } from "./FormModal.vue?vue&type=template&id=212dbedb&"
import script from "./FormModal.vue?vue&type=script&lang=js&"
export * from "./FormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\dev.marcdeloche.fr\\themes\\marcdeloche\\_dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('212dbedb', component.options)
    } else {
      api.reload('212dbedb', component.options)
    }
    module.hot.accept("./FormModal.vue?vue&type=template&id=212dbedb&", function () {
      api.rerender('212dbedb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/vuejs/components/Giftcard/FormModal.vue"
export default component.exports